<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { purposeOptions, sourceOptions } from '../utils/qprecoConstants';

defineProps({
  sourceInput: { type: String, default: 'external' },
  activeFiltersCount: { type: Number, default: 0 },
  activeFilterChips: { type: Array, default: () => [] },
});

defineEmits(['apply', 'clear', 'select-source', 'remove-filter']);

const searchInput = defineModel('searchInput', { type: String, default: '' });
const cityInput = defineModel('cityInput', { type: String, default: '' });
const neighborhoodInput = defineModel('neighborhoodInput', {
  type: String,
  default: '',
});
const purposeInput = defineModel('purposeInput', { type: String, default: '' });
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="sticky top-0 z-20 -mx-3 border-y border-lais-border bg-white/95 px-3 py-3 shadow-lais-soft backdrop-blur sm:-mx-5 sm:px-5 lg:-mx-8 lg:px-8"
  >
    <form class="grid gap-3" @submit.prevent="$emit('apply')">
      <div class="grid gap-2 xl:grid-cols-[minmax(260px,1.3fr)_auto]">
        <label class="relative min-w-0">
          <span
            class="i-lucide-search pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-lais-text-muted"
            aria-hidden="true"
          />
          <input
            v-model="searchInput"
            type="search"
            class="h-11 w-full rounded-lais border border-lais-border bg-white pl-10 pr-3 text-[14px] text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50"
            placeholder="Buscar por endereço, código, bairro ou cidade"
          />
        </label>
        <div class="grid grid-cols-2 gap-2 sm:flex">
          <LaisPrimaryButton type="submit" icon="i-lucide-search">
            Buscar
          </LaisPrimaryButton>
          <LaisPrimaryButton
            type="button"
            variant="ghost"
            icon="i-lucide-rotate-ccw"
            :disabled="!activeFiltersCount"
            @click="$emit('clear')"
          >
            Limpar
          </LaisPrimaryButton>
        </div>
      </div>

      <div class="grid gap-3 lg:grid-cols-[minmax(0,1fr)_360px]">
        <div class="grid gap-3 sm:grid-cols-3">
          <label
            class="grid gap-1 text-[12px] font-semibold text-lais-text-muted"
          >
            Cidade
            <input
              v-model="cityInput"
              type="text"
              class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] font-normal text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50"
              placeholder="Rio de Janeiro"
            />
          </label>
          <label
            class="grid gap-1 text-[12px] font-semibold text-lais-text-muted"
          >
            Bairro
            <input
              v-model="neighborhoodInput"
              type="text"
              class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] font-normal text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50"
              placeholder="Botafogo"
            />
          </label>
          <label
            class="grid gap-1 text-[12px] font-semibold text-lais-text-muted"
          >
            Finalidade
            <select
              v-model="purposeInput"
              class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] font-normal text-lais-text outline-none transition focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50"
            >
              <option
                v-for="option in purposeOptions"
                :key="option.value || 'all-purposes'"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </label>
        </div>

        <div class="grid gap-1">
          <span class="text-[12px] font-semibold text-lais-text-muted">
            Origem
          </span>
          <div
            class="grid grid-cols-2 gap-2 rounded-lais border border-lais-border bg-lais-bg-page p-1"
          >
            <button
              v-for="option in sourceOptions"
              :key="option.value"
              type="button"
              class="inline-flex h-9 items-center justify-center gap-2 rounded-lais-sm px-3 text-[12px] font-semibold transition"
              :class="
                sourceInput === option.value
                  ? 'bg-lais-primary text-white shadow-lais-soft'
                  : 'bg-transparent text-lais-text-muted hover:bg-white hover:text-lais-primary'
              "
              @click="$emit('select-source', option.value)"
            >
              <span class="size-3.5" :class="option.icon" aria-hidden="true" />
              {{ option.label }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <div
      v-if="activeFilterChips.length"
      class="mt-3 flex gap-2 overflow-x-auto pb-1"
    >
      <button
        v-for="chip in activeFilterChips"
        :key="chip.key"
        type="button"
        class="inline-flex shrink-0 items-center gap-2 rounded-full border border-lais-border bg-lais-bg-page px-3 py-1.5 text-[12px] font-semibold text-lais-text transition hover:border-lais-primary hover:text-lais-primary"
        @click="$emit('remove-filter', chip.key)"
      >
        {{ chip.label }}
        <span class="i-lucide-x size-3.5" aria-hidden="true" />
      </button>
    </div>
  </section>
</template>
